cb.define([], function () {
  var SH_sh_aftersalelist_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		var self = this;
		
		/*let gridModel = viewmodel.getGridModel();
		gridModel.on('afterSetDataSource', () => {
			const rows = gridModel.getRows();
			const actions = gridModel.getCache('actions');
			const actionsStates = [];
			rows.forEach(data => {
				const actionState = { };
				actions.forEach(action => {
					actionState[action.cItemName] = { visible: true };
					if (data.status == 3) {
						actionState["btnCustomerReceipt"] = { visible: false };
						actionState["btnEdit"] = { visible: false };
					}
					if(data.status != 2 && data.maintenancePlace!=0)
					{
						actionState["btnCustomerReceipt"] = { visible: false };
					}
					if(data.maintenancePlace==0 && data.status != 3)
					{
						actionState["btnCustomerReceipt"] = { visible: true };
					}
					if (data.status != 0) {
						actionState["btnDelete"] = { visible: false };
						actionState["btnEdit"] = { visible: false };
					}
				  });
				actionsStates.push(actionState);
			});
			gridModel.setActionsState(actionsStates);
		});*/
		
		
		viewmodel.on('assubmit', function (args) {
			var data = viewmodel.getGridModel().getSelectedRows();
			
			self.btnOnClike(viewmodel,args,"assubmit","sh_aftersalelist",data);
			
		});
		viewmodel.on('asstorereceipt', function (args) {
			var data = viewmodel.getGridModel().getSelectedRows();
			self.btnOnClike(viewmodel,args,"asstorereceipt","sh_aftersalelist",data);
		   
		});
		viewmodel.on('ascustomerreceipt', function (args) {
			var rowIndex = args.params.index;
			var data = viewmodel.getGridModel().getRow(rowIndex);
			self.btnOnClike(viewmodel,args,"ascustomerreceipt","sh_aftersalelist",data);
		});
    },
	btnOnClike : function(viewmodel,args , action , billnum , data){
		if(data.length <= 0)
		{
			 cb.utils.alert("请先选择数据");
			 return false;
		}
		var proxy = cb.rest.DynamicProxy.create({
          settle: { url: args.cSvcUrl, method: args.cHttpMethod }
        });
        var params = {
			action: action,
			billnum : billnum,
			data : JSON.stringify(data)
        };
        proxy.settle(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
		  if(params.action == 'assubmit')
			  cb.utils.alert("提交成功");
		  if(params.action == 'asstorereceipt')
			  cb.utils.alert("门店收货成功");
		  if(params.action == 'ascustomerreceipt')
			  cb.utils.alert("客户签收成功");
          viewmodel.execute('refresh');
        });
	},
 
  }
  try {
    module.exports = SH_sh_aftersalelist_VM_Extend;
  } catch (error) {

  }
  return SH_sh_aftersalelist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/SH/SH_sh_aftersalelist_VM.Extend.js